'use strict';

module.exports = function (element) {
    var windowWidth = $(window).width();
    var fixedElement = '.main-menu'; // Not available for checkout pages
    if ($(fixedElement).length && windowWidth < 769) {
        fixedElement = '.navbar-header';
    }

    var fixedHeaderHeight = $(fixedElement).outerHeight() ? $(fixedElement).outerHeight() : 0; // For checkout pages it will be always 0
    var position = element && element.length ? (element.offset().top - 20) - fixedHeaderHeight : 0;
    $('html, body').animate({
        scrollTop: position
    }, 500);
    if (!element) {
        $('.logo-home').focus();
    }
};
